import { render, staticRenderFns } from "./ModifyUserInfoModal.vue?vue&type=template&id=50bd7f35&scoped=true&"
import script from "./ModifyUserInfoModal.vue?vue&type=script&lang=js&"
export * from "./ModifyUserInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ModifyUserInfoModal.vue?vue&type=style&index=0&id=50bd7f35&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd7f35",
  null
  
)

export default component.exports